import { Component, Input, signal } from '@angular/core';
import { CameraEventFetchActionComponent } from './camera-event-fetch-action/camera-event-fetch-action.component';
import { CameraEventListComponent } from './camera-event-list/camera-event-list.component';
import { CameraEventFetchHistoryComponent } from './camera-event-fetch-history/camera-event-fetch-history.component';
import { CameraEventReplayComponent } from './camera-event-replay/camera-event-replay.component';
import { CameraDto, CameraEventFetchDto } from '../../../../../../api/gen';

@Component({
  selector: 'app-camera-events',
  standalone: true,
  imports: [
    CameraEventFetchActionComponent,
    CameraEventListComponent,
    CameraEventFetchHistoryComponent,
    CameraEventReplayComponent
  ],
  templateUrl: './camera-events.component.html',
  styleUrl: './camera-events.component.scss'
})
export class CameraEventsComponent {
  @Input() camera!: CameraDto;
  @Input() parkingSpaceId: string | null = null;

  selectedFetch = signal<CameraEventFetchDto | null>(null);
  historyKey = signal(0); // increment to force history reload

  onFetchCompleted(fetch: CameraEventFetchDto): void {
    this.selectedFetch.set(fetch);
    this.historyKey.update(k => k + 1);
  }

  onFetchSelected(fetch: CameraEventFetchDto): void {
    this.selectedFetch.set(fetch);
  }
}
